<template>
  <!-- eslint-disable max-len -->
  <div class='container'>
    <div class="game" v-if="started < 5">
      <h1>{{ msg }}</h1>
      <input type="text" v-model="char_one" :disabled="started !== 1">
      <input type="text" v-model="char_two" :disabled="started !== 2">
      <input type="text" v-model="char_three" :disabled="started !== 3">
      <input type="text" v-model="char_four" :disabled="started !== 4">
      <div class="button">
          <button @click="started = 1" v-if="started==0">
              יאללה מתחילות هيا لنبدأ
          </button>
          <div class="instractions" v-if="started>0">
            <p> כדי לקבל את הספרה עליכן לשלוח באישי לעמוד של קווין באינסטגרם للحصول على الرقم عليكن ارسال رسالة لصفحة كوين بي بالانستجرام</p>
            <h3 v-html="instractions[started - 1]"></h3>
            <p>אם תעמדו במשימה תקבלו חזרה את הסיפרה اذا نجحتن بالمهمة ستحصلن على الرقم للخزنة</p>
            <h2>بالنجاح! בהצלחה!</h2>
          </div>
      </div>
    </div>

    <youtube  v-else video-id="nElGRRL9_04" @ready="ready" :player-vars="{autoplay: 1}" ></youtube>
  </div>
</template>

<script>
import Vue from 'vue';

import VueYouTubeEmbed from 'vue-youtube-embed';

Vue.use(VueYouTubeEmbed);

// eslint-disable-next-line
function zeroPadded(num) {
  // 4 --> 04
  return num < 10 ? `0${num}` : num;
}
// eslint-disable-next-line
function hourConvert(hour) {
  // 15 --> 3
  return (hour % 12) || 12;
}

let intervalTimer = null;

export default {
  name: 'HelloWorld',
  data() {
    return {
      msg: 'הכספת השמורה בעולם الخزنة المخبأ بالعالم',
      instractions: [
        'צילום שלכן במפגש וירטואלי - ממש כמו שהיה עד עכשיו (תמונת גריד של כל המסכים) רק שבמקום שאתן תהיו החניכות מישהו אחר מהמשפחה יהיה! صورة لكن بالدرس الاونلاين- تمامًا  مثلما كان حتى الآن (صورة لجميع شاشات البنات) ولكن يجب ان يكون شخص اخر من العائلة كطالب بدلا منكن ',
        ' סרטון קצר (רק 20 שניות) בתצוגת גריד - שנראה כאילו אתן מעבירות חפץ אמיתי אחת לשנייה בין כל החניכות בקבוצה. فيديو قصير (فقط 20 ثانية) بعرض على شاشة الحاسوب - وبه يبدو أنكن تقومون بنقل شيء حقيقي من طالبة للطالبة التي تليها بين جميع أعضاء المجموعة ',
        'סרטון קצר (רק 20 שניות) שלכן סופרות עד 10 - כל אחת צריכה להגיד את המספר הבא כשמתחשק לה ויחד עליכן להגיע עד 10. אסור להגיד מספר שתי חניכות יחד. فيديو قصير (فقط 20 ثانية) وبه تقمن بالعد التصاعدي حتى رقم 10 - كل واحدة تقول الرقم التالي عندما تريد ذلك (لا يجب عليها ان تقول الرقم التالي فوراً) ومعاً يجب ان تصلوا للرقم  10. ممنوع لطالبتين قول نفس الرقم.',
        'על כולן להיכנס לניו-רואו ולהצטלם יחד בזום כשהרקע שלכן הוא התמונה שירדה מתקיית התמונות. עליכן לעמוד בדיוק בקווי המתאר של הדמות בתמונה يجب عليكن الدخول لنيو روو وكل واحدة تقوم بتحميل صورة لخلفيتها والتقاط صورة معاً . يجب أن تتصرفي تمامًا بحسب تخطيط الشكل في الصورة.',
      ],
      started: 0,
      char_one: '',
      char_two: '',
      char_three: '',
      char_four: '',
      player: null,
    };
  },
  methods: {
    ready(event) {
      this.player = event.target;
    },
    setTimer(seconds) {
      clearInterval(intervalTimer);
      this.timer(seconds);
      this.started = 1;
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + (seconds * 1000);
      this.displayTimeLeft(seconds);

      this.selectedTime = seconds;
      this.displayEndTime(end);
      this.countdown(end);
    },
    countdown(end) {
      intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);

        if (secondsLeft === 0) {
          this.endTime = 0;
        }

        if (secondsLeft < 0) {
          clearInterval(intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      this.msg = `${zeroPadded(minutes)}:${zeroPadded(seconds)}`;
    },
    displayEndTime(timestamp) {
      const end = new Date(timestamp);
      const hour = end.getHours();
      const minutes = end.getMinutes();

      this.endTime = `${zeroPadded(hour)}:${zeroPadded(minutes)}`;
    },
  },
  watch: {
    // eslint-disable-next-line
    started: function (isStarted, prev) {
      if (isStarted > 0 && prev === 0) {
        this.setTimer(1800);
      }
    },
    // eslint-disable-next-line
    char_one: function (val) {
      if (Number(val) === 8) {
        this.started = 2;
      }
    },
    // eslint-disable-next-line
    char_two: function (val) {
      if (Number(val) === 0) {
        this.started = 3;
      }
    },
    // eslint-disable-next-line
    char_three: function (val) {
      if (Number(val) === 6) {
        this.started = 4;
      }
    },
    // eslint-disable-next-line
    char_four: function (val) {
      if (Number(val) === 8) {
        this.started = 5;
      }
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
button{
    width:200px;
    height: 50px;
    margin:30px auto;
}
input{
    height:40px;
    border:none;
    border-bottom: 1px black solid;
    text-align:center;
    font-size: 2rem;
    width: calc( 25% - 20px );
}

 input:disabled{
    background: transparent;
}

h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue